let vendorTypes = [
  "accessories",
  "asooke",
  "assistant",
  "baileysnigeria",
  "beads",
  "belle",
  "bouquet",
  "bridal styling",
  "bridal stylist",
  "bride",
  "cake",
  "decor",
  "dj",
  "dress",
  "drink",
  "fabric",
  "fashion illustrator",
  "gele",
  "groom",
  "grooms suit",
  "hair",
  "henna",
  "jewelry",
  "lashes",
  "light assistant",
  "makeup",
  "mc",
  "media",
  "mua",
  "outfit",
  "photographer",
  "planner",
  "shoes",
  "special effects",
  "stylist",
  "suit",
  "undefined",
  "videographer",
  "videography",
  "wedding planner"
];

const traditionalVendorTypes = [
  "alaga",
  "asoebi",
  "attire",
  "bead",
  "bridal stylist",
  "bridesmaid stylist",
  "cake",
  "caterer",
  "cinematographer ",
  "cocktails",
  "coordinator",
  "creative director",
  "dj",
  "drinks",
  "dessert",
  "earings",
  "eru iyawo",
  "event childcare",
  "fabrics",
  "florist",
  "food",
  "gift packaging",
  "hair",
  "hotel",
  "jewellry",
  "kente",
  "live bands",
  "makeup artist",
  "mc",
  "music",
  "nails",
  "photobooth",
  "photographer",
  "planner",
  "refreshments",
  "rentals",
  "rings",
  "security",
  "service staff",
  "special effects",
  "shoes",
  "videographers",
  "turban",
  "venue",
  "transportation"
];
const whiteWeddingVendorTypes = [
  "attire",
  "bridal stylist",
  "bridal gown",
  "bridesmaid stylist",
  "cinematographer",
  "creative director",
  "earings",
  "florist",
  "hair",
  "hotel",
  "jewellry",
  "makeup artist",
  "music",
  "nails",
  "photographer",
  "planner",
  "rentals",
  "rings",
  "security",
  "service staff",
  "special effects",
  "shoes",
  "videographers",
  "turban",
  "venues",
  "transportation"
];
const receptionVendorTypes = [
  "attire",
  "bridal stylist",
  "bridal gown",
  "bridesmaid stylist",
  "cake ",
  "caterer",
  "cinematographer",
  "cocktails",
  "coordinator",
  "creative director",
  "dj",
  "drinks",
  "dessert",
  "earings",
  "event childcare",
  "live bands",
  "florist",
  "food",
  "gift packaging",
  "hair",
  "hotel",
  "jewellry",
  "makeup artist",
  "mc",
  "music",
  "nails",
  "photobooth",
  "photographer",
  "planner",
  "refreshments",
  "rentals",
  "rings",
  "security",
  "service staff",
  "special effects",
  "shoes",
  "videographers",
  "turban",
  "venue",
  "transportation"
];
const courtVendorTypes = [
  "attire",
  "bridal stylist",
  "bridal gown",
  "bridesmaid stylist",
  "cinematographer",
  "creative director",
  "earings",
  "florist",
  "hair",
  "hotel",
  "jewellry",
  "makeup artist",
  "music",
  "nails",
  "photographer",
  "planner",
  "rentals",
  "rings",
  "security",
  "service staff",
  "special effects",
  "shoes",
  "videographers",
  "turban",
  "venues",
  "transportation"
];
let countries = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antigua &amp; Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia &amp; Herzegovina",
  "Botswana",
  "Brazil",
  "British Virgin Islands",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Cape Verde",
  "Cayman Islands",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Congo",
  "Cook Islands",
  "Costa Rica",
  "Cote D Ivoire",
  "Croatia",
  "Cruise Ship",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Polynesia",
  "French West Indies",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kuwait",
  "Kyrgyz Republic",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Namibia",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Norway",
  "Oman",
  "Pakistan",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Pierre &amp; Miquelon",
  "Samoa",
  "San Marino",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "South Africa",
  "South Korea",
  "Spain",
  "Sri Lanka",
  "St Kitts &amp; Nevis",
  "St Lucia",
  "St Vincent",
  "St. Lucia",
  "Sudan",
  "Suriname",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor L'Este",
  "Togo",
  "Tonga",
  "Trinidad &amp; Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks &amp; Caicos",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "Uruguay",
  "Uzbekistan",
  "Venezuela",
  "Vietnam",
  "Virgin Islands (US)",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];

let nigeriaPriceRanges = [
  "25,000 and below",
  "25,000 - 50,000",
  "50,000 - 100,000",
  "100,000 - 250,000",
  "250,000 - 400,000",
  "400,000 - 600,000",
  "600,000 - 1,000,000",
  "1,000,000 - 2,000,000",
  "2,000,000 - 4,000,000",
  "4,000,000 and above"
];

let usPriceRanges = [
  "1,000 and below",
  "1,000 - 5,000",
  "5,000 - 15,000",
  "15,000 - 30,000",
  "30,000 - 50,000",
  "50,000 - 100,000",
  "100,000 - 250,000",
  "250,000 - 500,000",
  "500,000 - 1,000,000",
  "1,000,000 and above"
];

let defaultPackageOptions = {
  budget: nigeriaPriceRanges[5],
  flexibility: "Somewhat Flexible",
  ranking: "Affordability",
  types: ""
};
export {
  vendorTypes,
  countries,
  nigeriaPriceRanges,
  usPriceRanges,
  defaultPackageOptions,
  traditionalVendorTypes,
  whiteWeddingVendorTypes,
  receptionVendorTypes,
  courtVendorTypes
};



// WEBPACK FOOTER //
// ./src/constants.js